import { HttpError } from "@refinedev/core";
import { Create, SaveButton } from "@refinedev/mui";
import React from "react";
import { FormProvider } from "react-hook-form";
import { Branch, defaultBranch } from "types/branch";
import { useDefaultForm } from "../../components/form/useDefaultForm";
import { BranchForm } from "./BranchForm";

export default function CreateBranch() {
  const methods = useDefaultForm<Branch, HttpError>({
    defaultValues: defaultBranch,
  });

  return (
    <Create footerButtons={() => <SaveButton {...methods.saveButtonProps} />}>
      <FormProvider {...methods}>
        <BranchForm control={methods.control} createMode={true} />
      </FormProvider>
    </Create>
  );
}
